import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CurriculumEntityModel } from 'app/interfaces/candidate-entity.model';
import { CurriculaService } from 'app/services';

@Component({
  selector: 'app-cv-preview',
  templateUrl: './cv-preview.component.html',
  styleUrls: ['./cv-preview.component.scss']
})
export class CvPreviewComponent implements OnChanges, OnDestroy {
  @Input() applicationId: number = null;
  @Input() pages!: number;
  @Input() isModalExpanded: boolean = false;

  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  public imgs: any[] = [];

  constructor(
    private curriculaService: CurriculaService,
    private sanitizer: DomSanitizer
  ) { }

  async init() {
    this.imgs = [];
    const arr: any[] = [];
    await new Promise((resolve)=> {setTimeout(() => {resolve(true)}, 100)});
    // if (this.applicationId && this.pages && !!this.isModalExpanded) {
      for (let i = 0; i < this.pages; i++) {
        try {
          const p = await this.curriculaService.getCurriculaPage(this.applicationId, i).toPromise();
          // arr.push(this.curriculaService.getCurriculaPage(this.applicationId, i).toPromise())

          // this.imgs.push(this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(new Blob([p.body], { type: 'image/jpeg' }))));

          this.imgs[i] = (this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(new Blob([p.body], { type: 'image/jpeg' }))));
        } catch (e) { }
      }
      // const r = await Promise.all(arr);
      // r.forEach(e => {
      //   this.imgs.push(this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(new Blob([e.body], { type: 'image/jpeg' }))));
      // });
    //}
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes)
    if (changes && (changes.applicationId || (changes.isModalExpanded && (changes.isModalExpanded.currentValue === null)))) {
      this.init();
    }

  }

  ngOnDestroy(): void {
    this.imgs = [];
  }
}
